import { useLocation } from 'react-router-dom';
import { useIoContext } from '~/contexts';
const SYNTHETIC_BASE = 'https://example.invalid';
const ALLOWED_PATH_PREFIXES = [
    '/oauth/authorize'
];
export const decodeSameOriginPath = (search)=>{
    const raw = new URLSearchParams(search).get('next');
    if (raw == null || raw.length === 0) return null;
    let decoded;
    try {
        decoded = decodeURIComponent(raw);
    } catch (unused) {
        return null;
    }
    if (!decoded.startsWith('/')) return null;
    let parsed;
    try {
        parsed = new URL(decoded, SYNTHETIC_BASE);
    } catch (unused) {
        return null;
    }
    if (parsed.origin !== SYNTHETIC_BASE) return null;
    return parsed.pathname + parsed.search + parsed.hash;
};
const isPathAllowed = (path)=>ALLOWED_PATH_PREFIXES.some((prefix)=>path === prefix || path.startsWith("".concat(prefix, "?")) || path.startsWith("".concat(prefix, "/")));
export const safeNextParam = (search)=>{
    const path = decodeSameOriginPath(search);
    if (path == null) return null;
    if (!isPathAllowed(path)) return null;
    return path;
};
export const usePostAuthRedirect = ()=>{
    const { search } = useLocation();
    const { browser: { changeLocation, locationReload } } = useIoContext();
    return ()=>{
        const next = safeNextParam(search);
        if (next != null) {
            changeLocation(next);
        } else {
            locationReload();
        }
    };
};
